export class ConstantsBMELCodes {
    static readonly CODE_BUCHSTELLE: number         = 1;
    static readonly CODE_BETRIEBSNUMMER: number        = 2;
}
